import { WorkbenchTypeEnum } from 'src/app/enum/workbench/resume/workbench-type-enum';
import { TunnelData } from '../../tunnel/tunnel-data';
import { ResumeDto } from './resume-dto';
import { PackageTypeEnum } from 'src/app/enum/workbench/package-type-enum';
export class WorkbenchTunnelData extends TunnelData {
  id: string;
  resume: ResumeDto;
  init() {
    this.id = '';
    this.resume = new ResumeDto();
  }
  initFromConfig(config: any) {}

  get productsPrice() {
    let price = 0;

    this.resume?.products
      ?.filter(p => p.workbenchType !== WorkbenchTypeEnum.package)
      .map(product => {
        price += product.quantity * product.pv;
      });
    return price;
  }

  get packagesPrice() {
    let price = 0;
    this.resume?.products
      ?.filter(p => p.workbenchType === WorkbenchTypeEnum.package)
      .map(product => {
        price += product.quantity * product.pv;
      });
    return price;
  }

  get installationPrice() {
    let price = 0;
    this.resume?.products
      ?.filter(p => p.workbenchType === WorkbenchTypeEnum.package && p.packageType === PackageTypeEnum.Installation)
      .map(product => {
        price += product.quantity * product.pv;
      });
    return price;
  }

  get packagesWithoutInstallationPrice() {
    let price = 0;
    this.resume?.products
      ?.filter(p => p.workbenchType === WorkbenchTypeEnum.package && p.packageType !== PackageTypeEnum.Installation)
      .map(product => {
        price += product.quantity * product.pv;
      });
    return price;
  }

  get isInstallationIncluded(): boolean {
    return this.installationPrice > 0;
  }

  get totalQuantity() {
    let quantity = 0;
    this.resume.products.map(p => {
      if (p.workbenchType === WorkbenchTypeEnum.plan) {
        quantity += p.additionnalQuantity / 1000;
      }
    });
    return quantity;
  }

  get isCosentino() {
    return this.isInstallationIncluded; //J'ai pas d'autre moyen pour savoir s'il y a un plan cosentino. De tte manière, s'il y a un forfait de pose de pdt, on est sur du cosentino (pour le moment en tout cas)
  }
}
